// extracted by mini-css-extract-plugin
export var typeLarge = "FooterContent-module--type-large--ApNBm";
export var typeMedium = "FooterContent-module--type-medium--W5xOD";
export var typeBody = "FooterContent-module--type-body--wUvwk";
export var homeIcon = "FooterContent-module--home-icon--+D0iy";
export var footerInfo = "FooterContent-module--footer-info--gV-P+";